var _style, _path, _circle, _path2, _path3, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrokerCloseIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290 271",
    style: {
      enableBackground: "new 0 0 290 271"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#002D9C;}\n\t.st1{fill:#A6C8FF;}\n\t.st2{fill:#0078FF;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#D0E2FF;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,182.6c-0.8,0.8-0.8,2,0,2.8c0.8,0.8,2,0.8,2.8,0L18.6,182.6z M204,2c0-1.1-0.9-2-2-2l-18,0 c-1.1,0-2,0.9-2,2s0.9,2,2,2h16v16c0,1.1,0.9,2,2,2s2-0.9,2-2V2z M21.4,185.4l182-182l-2.8-2.8l-182,182L21.4,185.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.5,
    cy: 134.5,
    r: 111.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.6,174.6c-0.8,0.8-0.8,2,0,2.8c0.8,0.8,2,0.8,2.8,0L74.6,174.6z M252,2c0-1.1-0.9-2-2-2l-18,0 c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h16v16c0,1.1,0.9,2,2,2s2-0.9,2-2V2z M77.4,177.4l174-174l-2.8-2.8l-174,174L77.4,177.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.6,267.6c-0.8,0.8-0.8,2,0,2.8c0.8,0.8,2,0.8,2.8,0L68.6,267.6z M226,115c0-1.1-0.9-2-2-2h-18 c-1.1,0-2,0.9-2,2s0.9,2,2,2h16v16c0,1.1,0.9,2,2,2s2-0.9,2-2V115z M71.4,270.4l154-154l-2.8-2.8l-154,154L71.4,270.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98,201h80c4.4,0,8-3.6,8-8v-90l-37-36H98c-4.4,0-8,3.6-8,8v118C90,197.4,93.6,201,98,201z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149,95V67l37,36h-29C152.6,103,149,99.4,149,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112,118h52c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4h-52c-2.2,0-4-1.8-4-4l0,0C108,119.8,109.8,118,112,118z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112,172h52c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4h-52c-2.2,0-4-1.8-4-4l0,0C108,173.8,109.8,172,112,172z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112,134h40c2.2,0,4,1.8,4,4l0,0c0,2.2-1.8,4-4,4h-40c-2.2,0-4-1.8-4-4l0,0C108,135.8,109.8,134,112,134z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.5,166L238.5,166c20.2,0,36.5,16.3,36.5,36.5l0,0c0,20.2-16.3,36.5-36.5,36.5l0,0 c-20.2,0-36.5-16.3-36.5-36.5l0,0C202,182.3,218.3,166,238.5,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M243.7,188.9c1.4-1.4,3.8-1.5,5.2,0l3.1,3.1c1.5,1.4,1.4,3.8,0,5.2l-18.8,18.8c-0.2,0.2-0.4,0.3-0.7,0.3 l-6,0.6c-1.5,0.2-2.8-1.1-2.7-2.7l0.6-6c0-0.3,0.1-0.5,0.3-0.7L243.7,188.9z M247.2,190.6c-0.5-0.5-1.4-0.5-1.9,0l-2.1,2.1l5.1,5.1 l2.1-2.1c0.6-0.6,0.5-1.4,0-1.9l0,0L247.2,190.6L247.2,190.6z M246.6,199.5l-5.1-5.1l-14.8,14.8l-0.6,5.6l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0l5.6-0.6L246.6,199.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.5,48L42.5,48C57.7,48,70,60.3,70,75.5l0,0C70,90.7,57.7,103,42.5,103l0,0C27.3,103,15,90.7,15,75.5l0,0 C15,60.3,27.3,48,42.5,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M53,67.9c0.3,0.3,0.4,0.9,0,1.2L38.8,83.7l-6.8-7c-0.3-0.3-0.3-0.9,0-1.2c0.3-0.3,0.9-0.3,1.2,0l5.5,5.7 l13-13.3C52.1,67.6,52.6,67.6,53,67.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokerCloseIllustration);
export default __webpack_public_path__ + "static/media/broker-close-illustration.7308c1adc53f650bb94ca13245fc4329.svg";
export { ForwardRef as ReactComponent };